<template>
	
<div class="form">

	<div class="form-title">{{ section.summary.form.title1 }}</div>

	<p>Strengthening bone is {{ scale[$getValue('aid.benefits.strength')] }} important to me</p>

	<p>Lowering the chance of further fractures and protecting the spine is {{ scale[$getValue('aid.benefits.chance')] }} important to me</p>

	<p>Maintaining independence is {{ scale[$getValue('aid.benefits.independance')] }} important to me</p>

	<p>It is {{ scale[$getValue('aid.concerns.longterm')] }} likely that I would be put off taking this medicine because of concerns about rare long-term issues with medicines such as jaw bone problems</p>
	
	<p>It is {{ scale[$getValue('aid.concerns.sideeffects')] }} likely that I would be put off taking this medicine because of concerns about common side-effects with medicines such as indigestion and reflux</p>

	<p>{{ feeling }} {{ treatment }}</p>

	<div class="form-title is-divide">{{ section.summary.form.title2 }}</div>

	<p>
		{{ prescriptionText }}
	</p>

	<p v-if="supplementText">
		{{ supplementText }}
	</p>

	<p>
		{{ followupText }}
	</p>

	<p v-if="other">
		My unanswered questions, concerns or comments: {{ other }}
	</p>

</div>

</template>

<script>

export default {

	props: ['section'],

	data: function() {

		return {
			feelingNames: {
				1: "I am willing to take the medicine",
				2: "I am not sure about taking the medicine",
				3: "I prefer not to take the medicine"
			},
			scale: {
				1: 'not at all',
				2: 'slightly',
				3: 'moderately',
				4: 'very',
				5: 'extremely'
			},
			prescription: {
				1: 'My GP will issue my prescription / provide my medicine. I should contact my GP in',
				2: 'My hospital will provide my medicine. I should expect to hear from the hospital in',
				3: 'I prefer not to have a prescription / receive a medicine'
			},
			supplements: {
				1: 'My GP will prescribe calcium supplements.',
				2: 'My GP will prescribe calcium and vitamin D supplements.',
				3: 'My GP will prescribe Vitamin D supplements.',
				4: 'I will take over the counter calcium supplements.',
				5: 'I will take over the counter calcium and vitamin D supplements.',
				6: 'I will take over the counter Vitamin D supplements.'
			},
			timeline: {
				1: '1 week',
				2: '2 weeks',
				3: '3 weeks',
				4: '4 weeks',
				5: '5 weeks',
				6: '6 weeks'
			},
			followupAction: {
				1: 'by phone',
				2: 'by letter',
				3: 'by email',
				4: 'by text',
				5: 'in person'
			}
		}

	},

	computed: {

		prescriptionText: function() {

			var text = []

			if (this.$getValue('aid.next.prescription') < 4) {

				text.push(this.prescription[this.$getValue('aid.next.prescription')])

			}

			if (this.$getValue('aid.next.prescription') < 3) {

				if (this.$getValue('aid.next.timeline') < 7) {

					text.push(this.timeline[this.$getValue('aid.next.timeline')])

				} else {

					text.push(this.$getValue('aid.next.text') + ' weeks')

				}

			} else if (this.$getValue('aid.next.prescription') === 4) {

				text.push(this.$getValue('aid.next.text'))

			}

			return text.join(' ')

		},

		supplementText: function() {

			if (this.$getValue('aid.supplements.recommended') === 1) {

				var text = []

				text.push(this.supplements[this.$getValue('aid.supplements.action')])

				return text.join(' ')

			} else {

				return false

			}

		},

		followupText: function() {

			var text = []

			if (this.$getValue('aid.followup.accept') === 1) {

				text.push('The Fracture Liaison Service team will follow up with me')

				text.push(this.followupAction[this.$getValue('aid.followup.action')])
				
				text.push(' in ' + this.$getValue('aid.followup.timeline') + ' weeks')

			} else if (this.$getValue('aid.followup.accept') === 2) {

				if (this.$getValue('aid.followup.check').length === 2) {

					text.push('If I have any side effects or issues I should contact my GP or the Fracture Liaison Service')

				} else if (this.$getValue('aid.followup.check')[0] === 1) {

					text.push('If I have any side effects or issues I should contact my GP')

				} else {

					text.push('If I have any side effects or issues I should contact the Fracture Liaison service ')

				}

			}

			return text.join(' ')

		},

		named: function() {
			
			return this.$store.getters['logic/variable/named']

		},

		treatment: function() {

			return (this.values[this.named['aid.treatment']] === null) ? '' : this.$_.findWhere(this.$store.getters['data/setup'].treatments.options, {
				id: this.values[this.named['aid.treatment']]
			}).name 

		},

		feeling: function() {

			return this.feelingNames[this.values[this.named['aid.feeling']]]

		},

		steps: function() {

			var steps = []

			steps.push(this.section.form.next.prescription + ' ' + this.values[this.named['aid.next.prescription']] + ' weeks')

			steps.push(this.section.form.next.followup + ' ' + this.values[this.named['aid.next.followup']] + ' weeks')

			if (this.values[this.named['aid.next.text']]) {

				steps.push(this.values[this.named['aid.next.text']])
					
			}

			return steps

		},

		other: function() {

			return (this.values[this.named['aid.text']]) ? this.values[this.named['aid.text']] : false

		}

	}
	
}

</script>

<style scoped>

.form {
	margin-bottom: 32px;
}

.is-pdf {
	margin-bottom: 10px;
}

.form-title {
	color: #343434;
	margin-bottom: 32px;
	font-size: 20px;
	text-transform: uppercase;
	font-weight: 600;
}

.is-pdf .form-title {
	font-size: 16px;
	margin-bottom: 10px;
}

.form-title.is-divide {
	padding-top: 32px;
	margin-top: 32px;
	border-top: 1px solid var(--aid-color);

}

.is-pdf .form-title.is-divide {
	border-top: 0px;
	padding-top: 0px;
	margin-top: 0px;
}

.form p {
	font-size: 18px;
	line-height: 22px;
	color: #343434;
	margin-bottom: 22px;
}

.is-pdf .form p {
	font-size: 14px;
	line-height: 16px;
	margin-bottom: 10px;
}

.form p:last-child {
	margin-bottom: 0px;
}

.form p span {
	display: block;
}

</style>